import { DeletePaymentAccountsApi } from "@/features/accounts/payment/scraping/services/delete-accounts-api";
import { DeletePaymentAccountsRequestModel } from "@/features/accounts/payment/scraping/services/delete-accounts-model";

/// MoneyLook 口座削除処理
export class DeletePaymentAccountsService {
  private deletePaymentAccountsApi = new DeletePaymentAccountsApi();

  /**
   * MoneyLook 口座削除API実行
   */
  public async deletePaymentAccounts(param: DeletePaymentAccountsRequestModel) {
    return await this.deletePaymentAccountsApi.deletePaymentAccounts(param);
  }
}